// API Base URL Configuration
// In production, always use the full API server URL to ensure proper routing
export const API_BASE_URL = 
  process.env.NODE_ENV === 'production' 
    ? (process.env.REACT_APP_API_BASE_URL || "https://spacepings.space")
    : (process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:5000");

// Additional configuration for better error handling
export const APP_CONFIG = {
  API_TIMEOUT: 10000, // 10 seconds
  RETRY_ATTEMPTS: 3,
  CIRCUIT_BREAKER_THRESHOLD: 5,
  AUTH_CHECK_INTERVAL: 60000, // 1 minute
  DEBUG_MODE: process.env.NODE_ENV === 'development',
  ANALYTICS_ENABLED: process.env.NODE_ENV === 'production',
};
